interface SocialIconsProps {
  centered?: boolean
}

/**
 * Social Media Icons Component
 * Uses Font Awesome 6 brand icons
 */
const SocialIcons = ({ centered = false }: SocialIconsProps) => {
  return (
    <div className={`sosmed-icon ${centered ? '' : 'float-right'} d-inline-flex`}>
      <a 
        href="https://www.facebook.com/keith.callies" 
        target="_blank" 
        rel="noopener noreferrer"
        aria-label="Facebook"
      >
        <i className="fab fa-facebook-f"></i>
      </a>
      <a 
        href="https://www.instagram.com/relentless.e.d.u/" 
        target="_blank" 
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <i className="fab fa-instagram"></i>
      </a>
    </div>
  )
}

export default SocialIcons
